import React from 'react'
import { Route, IndexRedirect } from 'react-router'
import { ARTIST_PORTAL_ROUTE, SIGN_IN_ROUTE } from 'config'
import { routes as UserRoutes } from './user'
import { isAuthenticated } from './auth'
import { AuthorizedRoute, UnauthorizedRoute } from 'components'
import LayoutUnauthorized from './layout-unauthorized'
import LayoutAuthorized from './layout-authorized'
import Terms from './terms'
import { routes as DashboardRoutes } from './dashboard'
import { routes as AccountRoutes } from './account'
import { routes as ProfileRoutes } from './profile'
import AdminRedirect from './admin-redirect'

const Routes = (
  <Route path={ARTIST_PORTAL_ROUTE}>
    <IndexRedirect to="dashboard" />
    <Route path="admin-redirect" component={AdminRedirect} />

    {/* Authorized Routes */}
    <AuthorizedRoute authFunction={isAuthenticated} redirect={SIGN_IN_ROUTE}>
      <Route path={ARTIST_PORTAL_ROUTE + '/terms'} component={Terms} />
      <Route component={LayoutAuthorized}>
        {DashboardRoutes}
        {AccountRoutes}
        {ProfileRoutes}
      </Route>
    </AuthorizedRoute>

    {/* Unauthorized Routes */}
    <UnauthorizedRoute
      authFunction={isAuthenticated}
      redirect={ARTIST_PORTAL_ROUTE}
      component={LayoutUnauthorized}
    >
      {UserRoutes}
    </UnauthorizedRoute>
  </Route>
)

export default Routes
